export const allProducts = [
  // PULSES
  {
    id: 1,
    name: 'Toor Dal (Pigeon Peas)',
    category: 'Pulses',
    description: 'Premium quality yellow split pigeon peas, rich in protein and essential nutrients. Ideal for traditional Indian dal preparations and international cuisines.',
    image: 'https://public.readdy.ai/ai/img_res/65e5a2da5e8d31e2356edd2bc94e5108.jpg',
    details: {
      origin: 'Maharashtra, India',
      packaging: '25kg, 50kg PP Bags',
      shelfLife: '12 months',
      certifications: ['FSSAI', 'ISO 22000', 'Export Quality'],
    },
    specifications: [
      { label: 'Moisture Content', value: 'Max 12%' },
      { label: 'Protein Content', value: '20-22%' },
      { label: 'Purity', value: '99%' },
      { label: 'Foreign Matter', value: 'Max 0.5%' },
    ],
  },
  {
    id: 2,
    name: 'Moong Dal (Green Gram)',
    category: 'Pulses',
    description: 'High-quality green gram split, known for easy digestion and nutritional value. Perfect for soups, curries, and healthy preparations.',
    image: 'https://readdy.ai/api/search-image?query=Detailed%20close%20up%20photograph%20of%20bright%20yellow%20moong%20dal%20green%20gram%20split%20lentils%20showing%20small%20oval%20shaped%20grains%20with%20vibrant%20golden%20yellow%20color%20and%20smooth%20surface%20texture%20arranged%20on%20clean%20white%20background%20professional%20product%20photography%20sharp%20focus%20high%20resolution%20for%20export%20catalog&width=400&height=400&seq=moong-dal-v2&orientation=squarish',
    details: {
      origin: 'Rajasthan, India',
      packaging: '25kg, 50kg PP Bags',
      shelfLife: '12 months',
      certifications: ['FSSAI', 'ISO 22000', 'Organic Certified'],
    },
    specifications: [
      { label: 'Moisture Content', value: 'Max 10%' },
      { label: 'Protein Content', value: '24-26%' },
      { label: 'Purity', value: '99.5%' },
      { label: 'Split Ratio', value: '95% min' },
    ],
  },
  {
    id: 3,
    name: 'Chana Dal (Bengal Gram)',
    category: 'Pulses',
    description: 'Premium split Bengal gram with distinct nutty flavor. Versatile pulse used in various culinary applications across cultures.',
    image: 'https://readdy.ai/api/search-image?query=High%20resolution%20macro%20photography%20of%20chana%20dal%20bengal%20gram%20split%20chickpeas%20showing%20larger%20sized%20grains%20with%20deep%20golden%20yellow%20color%20and%20characteristic%20split%20texture%20arranged%20on%20pure%20white%20background%20professional%20food%20product%20photography%20sharp%20detail%20for%20agricultural%20export%20business&width=400&height=400&seq=chana-dal-v2&orientation=squarish',
    details: {
      origin: 'Madhya Pradesh, India',
      packaging: '25kg, 50kg PP Bags',
      shelfLife: '12 months',
      certifications: ['FSSAI', 'ISO 22000', 'Export Quality'],
    },
    specifications: [
      { label: 'Moisture Content', value: 'Max 11%' },
      { label: 'Protein Content', value: '22-24%' },
      { label: 'Purity', value: '99%' },
      { label: 'Foreign Matter', value: 'Max 0.3%' },
    ],
  },
  {
    id: 4,
    name: 'Masoor Dal (Red Lentils)',
    category: 'Pulses',
    description: 'Premium quality red lentils with quick cooking properties. Excellent source of protein and dietary fiber for healthy meals.',
    image: 'https://readdy.ai/api/search-image?query=Detailed%20macro%20shot%20of%20masoor%20dal%20red%20lentils%20showing%20small%20round%20flat%20shaped%20grains%20with%20bright%20coral%20orange%20red%20color%20and%20smooth%20surface%20texture%20arranged%20on%20white%20background%20professional%20product%20photography%20high%20detail%20sharp%20focus%20for%20export%20quality%20catalog&width=400&height=400&seq=masoor-dal-v2&orientation=squarish',
    details: {
      origin: 'Uttar Pradesh, India',
      packaging: '25kg, 50kg PP Bags',
      shelfLife: '12 months',
      certifications: ['FSSAI', 'ISO 22000', 'Export Quality'],
    },
    specifications: [
      { label: 'Moisture Content', value: 'Max 12%' },
      { label: 'Protein Content', value: '25-28%' },
      { label: 'Purity', value: '99%' },
      { label: 'Cooking Time', value: '15-20 min' },
    ],
  },
  {
    id: 5,
    name: 'Urad Dal (Black Gram)',
    category: 'Pulses',
    description: 'High-grade black gram dal, essential ingredient in South Indian cuisine. Rich in protein and minerals for nutritious diets.',
    image: 'https://readdy.ai/api/search-image?query=Close%20up%20macro%20photography%20of%20urad%20dal%20black%20gram%20split%20lentils%20showing%20creamy%20white%20colored%20oval%20shaped%20grains%20with%20smooth%20texture%20after%20dehusking%20arranged%20on%20pure%20white%20background%20professional%20food%20photography%20sharp%20focus%20high%20resolution%20for%20agricultural%20product%20catalog&width=400&height=400&seq=urad-dal-v2&orientation=squarish',
    details: {
      origin: 'Andhra Pradesh, India',
      packaging: '25kg, 50kg PP Bags',
      shelfLife: '12 months',
      certifications: ['FSSAI', 'ISO 22000', 'Export Quality'],
    },
    specifications: [
      { label: 'Moisture Content', value: 'Max 11%' },
      { label: 'Protein Content', value: '24-26%' },
      { label: 'Purity', value: '99.5%' },
      { label: 'Split Quality', value: 'Premium' },
    ],
  },
  {
    id: 6,
    name: 'Kabuli Chana (Chickpeas)',
    category: 'Pulses',
    description: 'Premium whole chickpeas with large size and excellent quality. Popular worldwide for salads, curries, and hummus preparations.',
    image: 'https://readdy.ai/api/search-image?query=High%20detail%20macro%20shot%20of%20kabuli%20chana%20chickpeas%20showing%20large%20round%20whole%20chickpeas%20with%20creamy%20beige%20tan%20color%20and%20characteristic%20wrinkled%20texture%20arranged%20on%20white%20background%20professional%20product%20photography%20sharp%20focus%20for%20export%20quality%20catalog&width=400&height=400&seq=kabuli-chana-v2&orientation=squarish',
    details: {
      origin: 'Karnataka, India',
      packaging: '25kg, 50kg PP Bags',
      shelfLife: '12 months',
      certifications: ['FSSAI', 'ISO 22000', 'Export Quality'],
    },
    specifications: [
      { label: 'Moisture Content', value: 'Max 12%' },
      { label: 'Protein Content', value: '18-20%' },
      { label: 'Purity', value: '99%' },
      { label: 'Size', value: '8-9mm' },
    ],
  },

  // SPICES
  {
    id: 7,
    name: 'Turmeric Powder',
    category: 'Spices',
    description: 'Premium quality turmeric powder with high curcumin content. Vibrant golden color and earthy aroma, essential for culinary and wellness applications.',
    image: 'https://readdy.ai/api/search-image?query=Close%20up%20macro%20photograph%20of%20fine%20turmeric%20powder%20showing%20vibrant%20deep%20golden%20yellow%20orange%20color%20with%20smooth%20powdery%20texture%20arranged%20in%20a%20neat%20pile%20on%20pure%20white%20background%20professional%20spice%20photography%20high%20detail%20sharp%20focus%20for%20export%20quality%20catalog&width=400&height=400&seq=turmeric-v2&orientation=squarish',
    details: {
      origin: 'Tamil Nadu, India',
      packaging: '1kg, 5kg, 25kg',
      shelfLife: '24 months',
      certifications: ['FSSAI', 'ISO 22000', 'Spices Board Certified'],
    },
    specifications: [
      { label: 'Curcumin Content', value: '3-5%' },
      { label: 'Moisture Content', value: 'Max 10%' },
      { label: 'Total Ash', value: 'Max 9%' },
      { label: 'Mesh Size', value: '60-80 mesh' },
    ],
  },
  {
    id: 8,
    name: 'Red Chili Powder',
    category: 'Spices',
    description: 'Fiery red chili powder with perfect balance of heat and flavor. Sourced from premium chili varieties for authentic taste.',
    image: 'https://readdy.ai/api/search-image?query=Detailed%20macro%20shot%20of%20red%20chili%20powder%20showing%20vibrant%20deep%20red%20crimson%20color%20with%20fine%20powdery%20texture%20arranged%20in%20a%20smooth%20pile%20on%20white%20background%20professional%20spice%20product%20photography%20high%20resolution%20sharp%20focus%20for%20agricultural%20export%20catalog&width=400&height=400&seq=red-chili-v2&orientation=squarish',
    details: {
      origin: 'Andhra Pradesh, India',
      packaging: '1kg, 5kg, 25kg',
      shelfLife: '18 months',
      certifications: ['FSSAI', 'ISO 22000', 'Spices Board Certified'],
    },
    specifications: [
      { label: 'Heat Level (SHU)', value: '30,000-50,000' },
      { label: 'Moisture Content', value: 'Max 10%' },
      { label: 'Color Value', value: '80-100 ASTA' },
      { label: 'Purity', value: '99%' },
    ],
  },
  {
    id: 9,
    name: 'Coriander Powder',
    category: 'Spices',
    description: 'Finely ground coriander powder with aromatic fragrance. Essential spice for curries, marinades, and spice blends.',
    image: 'https://readdy.ai/api/search-image?query=High%20resolution%20macro%20photography%20of%20coriander%20powder%20showing%20warm%20light%20brown%20tan%20color%20with%20fine%20smooth%20powdery%20texture%20arranged%20in%20a%20neat%20pile%20on%20pure%20white%20background%20professional%20spice%20photography%20sharp%20detail%20for%20export%20quality%20catalog&width=400&height=400&seq=coriander-v2&orientation=squarish',
    details: {
      origin: 'Rajasthan, India',
      packaging: '1kg, 5kg, 25kg',
      shelfLife: '18 months',
      certifications: ['FSSAI', 'ISO 22000', 'Spices Board Certified'],
    },
    specifications: [
      { label: 'Moisture Content', value: 'Max 10%' },
      { label: 'Volatile Oil', value: 'Min 0.4%' },
      { label: 'Total Ash', value: 'Max 7%' },
      { label: 'Mesh Size', value: '40-60 mesh' },
    ],
  },
  {
    id: 10,
    name: 'Cumin Seeds',
    category: 'Spices',
    description: 'Premium quality cumin seeds with intense aroma and flavor. Widely used spice in global cuisines for tempering and seasoning.',
    image: 'https://readdy.ai/api/search-image?query=Detailed%20close%20up%20macro%20shot%20of%20cumin%20seeds%20showing%20elongated%20ridged%20seeds%20with%20natural%20brown%20tan%20color%20and%20characteristic%20striped%20texture%20arranged%20on%20white%20background%20professional%20spice%20photography%20high%20detail%20sharp%20focus%20for%20agricultural%20export%20business&width=400&height=400&seq=cumin-v2&orientation=squarish',
    details: {
      origin: 'Gujarat, India',
      packaging: '5kg, 10kg, 25kg',
      shelfLife: '24 months',
      certifications: ['FSSAI', 'ISO 22000', 'Spices Board Certified'],
    },
    specifications: [
      { label: 'Moisture Content', value: 'Max 9%' },
      { label: 'Volatile Oil', value: 'Min 2.5%' },
      { label: 'Purity', value: '99%' },
      { label: 'Quality Grade', value: 'Machine Clean' },
    ],
  },
  {
    id: 11,
    name: 'Black Pepper',
    category: 'Spices',
    description: 'Premium grade whole black pepper with pungent flavor. Known as the king of spices, sourced from Kerala plantations.',
    image: 'https://readdy.ai/api/search-image?query=High%20resolution%20macro%20photography%20of%20whole%20black%20peppercorns%20showing%20round%20spherical%20berries%20with%20dark%20black%20wrinkled%20textured%20surface%20arranged%20on%20pure%20white%20background%20professional%20spice%20product%20photography%20sharp%20focus%20high%20detail%20for%20export%20quality%20catalog&width=400&height=400&seq=black-pepper-v2&orientation=squarish',
    details: {
      origin: 'Kerala, India',
      packaging: '5kg, 10kg, 25kg',
      shelfLife: '24 months',
      certifications: ['FSSAI', 'ISO 22000', 'Spices Board Certified'],
    },
    specifications: [
      { label: 'Moisture Content', value: 'Max 12%' },
      { label: 'Piperine Content', value: 'Min 4.5%' },
      { label: 'Bulk Density', value: '500-600 g/l' },
      { label: 'Size', value: '4.5-5mm' },
    ],
  },
  {
    id: 12,
    name: 'Cardamom',
    category: 'Spices',
    description: 'Premium green cardamom pods with intense aroma. Highly valued spice for sweet and savory dishes, beverages, and desserts.',
    image: 'https://readdy.ai/api/search-image?query=Detailed%20macro%20shot%20of%20green%20cardamom%20pods%20showing%20oval%20shaped%20pods%20with%20natural%20light%20green%20color%20and%20characteristic%20ridged%20texture%20arranged%20on%20white%20background%20professional%20spice%20photography%20high%20resolution%20sharp%20focus%20for%20agricultural%20export%20catalog&width=400&height=400&seq=cardamom-v2&orientation=squarish',
    details: {
      origin: 'Kerala, India',
      packaging: '1kg, 5kg, 10kg',
      shelfLife: '24 months',
      certifications: ['FSSAI', 'ISO 22000', 'Spices Board Certified'],
    },
    specifications: [
      { label: 'Moisture Content', value: 'Max 12%' },
      { label: 'Volatile Oil', value: 'Min 4%' },
      { label: 'Size Grade', value: '7-8mm' },
      { label: 'Color', value: 'Natural Green' },
    ],
  },

  // RICE
  {
    id: 13,
    name: 'Basmati Rice (Premium)',
    category: 'Rice',
    description: 'Extra-long grain premium basmati rice with distinctive aroma. Aged to perfection for superior cooking quality and taste.',
    image: 'https://readdy.ai/api/search-image?query=High%20detail%20macro%20photography%20of%20premium%20basmati%20rice%20showing%20extra%20long%20slender%20white%20rice%20grains%20with%20smooth%20texture%20and%20characteristic%20elongated%20shape%20arranged%20on%20pure%20white%20background%20professional%20food%20photography%20sharp%20focus%20for%20export%20quality%20catalog&width=400&height=400&seq=basmati-v2&orientation=squarish',
    details: {
      origin: 'Punjab, India',
      packaging: '5kg, 10kg, 25kg',
      shelfLife: '18 months',
      certifications: ['FSSAI', 'ISO 22000', 'Export Quality', 'Aged Rice'],
    },
    specifications: [
      { label: 'Grain Length', value: '8.3mm min' },
      { label: 'Moisture Content', value: 'Max 12%' },
      { label: 'Broken Grains', value: 'Max 1%' },
      { label: 'Aging Period', value: '12+ months' },
    ],
  },
  {
    id: 14,
    name: 'Sona Masoori Rice',
    category: 'Rice',
    description: 'Premium quality medium-grain rice, lightweight and aromatic. Popular choice for daily meals across South India.',
    image: 'https://readdy.ai/api/search-image?query=Close%20up%20macro%20shot%20of%20sona%20masoori%20rice%20showing%20medium%20length%20white%20rice%20grains%20with%20smooth%20surface%20and%20uniform%20size%20arranged%20on%20white%20background%20professional%20product%20photography%20high%20resolution%20sharp%20focus%20for%20agricultural%20export%20business&width=400&height=400&seq=sona-masoori-v2&orientation=squarish',
    details: {
      origin: 'Andhra Pradesh, India',
      packaging: '5kg, 10kg, 25kg',
      shelfLife: '12 months',
      certifications: ['FSSAI', 'ISO 22000', 'Export Quality'],
    },
    specifications: [
      { label: 'Grain Length', value: '5-6mm' },
      { label: 'Moisture Content', value: 'Max 14%' },
      { label: 'Broken Grains', value: 'Max 5%' },
      { label: 'Purity', value: '99%' },
    ],
  },
  {
    id: 15,
    name: 'Parboiled Rice',
    category: 'Rice',
    description: 'Nutritious parboiled rice with enhanced vitamin content. Ideal for bulk cooking and institutional requirements.',
    image: 'https://readdy.ai/api/search-image?query=Detailed%20macro%20photography%20of%20parboiled%20rice%20showing%20long%20grain%20rice%20with%20light%20golden%20amber%20color%20and%20smooth%20glossy%20surface%20texture%20arranged%20on%20pure%20white%20background%20professional%20food%20product%20photography%20sharp%20focus%20for%20export%20catalog&width=400&height=400&seq=parboiled-v2&orientation=squarish',
    details: {
      origin: 'Tamil Nadu, India',
      packaging: '10kg, 25kg, 50kg',
      shelfLife: '12 months',
      certifications: ['FSSAI', 'ISO 22000', 'Export Quality'],
    },
    specifications: [
      { label: 'Grain Type', value: 'Long Grain' },
      { label: 'Moisture Content', value: 'Max 14%' },
      { label: 'Broken Grains', value: 'Max 5%' },
      { label: 'Processing', value: 'Steam Treated' },
    ],
  },
  {
    id: 16,
    name: 'Brown Rice (Organic)',
    category: 'Rice',
    description: 'Certified organic brown rice with intact bran layer. Nutrient-rich whole grain option for health-conscious consumers.',
    image: 'https://readdy.ai/api/search-image?query=High%20resolution%20macro%20shot%20of%20organic%20brown%20rice%20showing%20long%20grain%20rice%20with%20natural%20tan%20brown%20color%20and%20intact%20bran%20layer%20texture%20arranged%20on%20white%20background%20professional%20product%20photography%20sharp%20detail%20for%20agricultural%20export%20quality%20catalog&width=400&height=400&seq=brown-rice-v2&orientation=squarish',
    details: {
      origin: 'Uttarakhand, India',
      packaging: '5kg, 10kg, 25kg',
      shelfLife: '9 months',
      certifications: ['FSSAI', 'ISO 22000', 'Organic Certified', 'Export Quality'],
    },
    specifications: [
      { label: 'Grain Type', value: 'Long Grain' },
      { label: 'Moisture Content', value: 'Max 12%' },
      { label: 'Bran Retention', value: '100%' },
      { label: 'Certification', value: 'USDA Organic' },
    ],
  },

  // MAIZE
  {
    id: 17,
    name: 'Yellow Corn (Feed Grade)',
    category: 'Maize',
    description: 'High-quality yellow corn suitable for animal feed and industrial applications. Consistent quality with excellent nutritional value.',
    image: 'https://readdy.ai/api/search-image?query=Detailed%20close%20up%20macro%20photography%20of%20yellow%20corn%20kernels%20showing%20individual%20bright%20golden%20yellow%20corn%20grains%20with%20smooth%20rounded%20shape%20and%20characteristic%20dent%20arranged%20on%20pure%20white%20background%20professional%20agricultural%20product%20photography%20sharp%20focus%20high%20detail&width=400&height=400&seq=yellow-corn-v2&orientation=squarish',
    details: {
      origin: 'Karnataka, India',
      packaging: '25kg, 50kg PP Bags',
      shelfLife: '6 months',
      certifications: ['FSSAI', 'ISO 22000', 'Export Quality'],
    },
    specifications: [
      { label: 'Moisture Content', value: 'Max 14%' },
      { label: 'Foreign Matter', value: 'Max 2%' },
      { label: 'Protein Content', value: '8-10%' },
      { label: 'Test Weight', value: '70-75 kg/hl' },
    ],
  },
  {
    id: 18,
    name: 'White Maize',
    category: 'Maize',
    description: 'Premium white maize kernels for food processing and industrial use. Clean, uniform quality meeting international standards.',
    image: 'https://readdy.ai/api/search-image?query=High%20resolution%20macro%20shot%20of%20white%20maize%20corn%20kernels%20showing%20individual%20creamy%20white%20colored%20corn%20grains%20with%20smooth%20surface%20and%20uniform%20rounded%20shape%20arranged%20on%20white%20background%20professional%20product%20photography%20sharp%20focus%20for%20export%20quality%20catalog&width=400&height=400&seq=white-maize-v2&orientation=squarish',
    details: {
      origin: 'Maharashtra, India',
      packaging: '25kg, 50kg PP Bags',
      shelfLife: '6 months',
      certifications: ['FSSAI', 'ISO 22000', 'Export Quality'],
    },
    specifications: [
      { label: 'Moisture Content', value: 'Max 13%' },
      { label: 'Foreign Matter', value: 'Max 1%' },
      { label: 'Protein Content', value: '9-11%' },
      { label: 'Damaged Kernels', value: 'Max 3%' },
    ],
  },
  {
    id: 19,
    name: 'Sweet Corn',
    category: 'Maize',
    description: 'Premium sweet corn with high sugar content. Perfect for fresh consumption and food processing applications.',
    image: 'https://readdy.ai/api/search-image?query=Detailed%20macro%20photography%20of%20sweet%20corn%20kernels%20showing%20plump%20bright%20yellow%20golden%20kernels%20with%20glossy%20surface%20and%20characteristic%20sweet%20corn%20shape%20arranged%20on%20pure%20white%20background%20professional%20food%20photography%20high%20detail%20sharp%20focus%20for%20export%20catalog&width=400&height=400&seq=sweet-corn-v2&orientation=squarish',
    details: {
      origin: 'Punjab, India',
      packaging: '10kg, 20kg Boxes',
      shelfLife: '3 months (frozen)',
      certifications: ['FSSAI', 'ISO 22000', 'Export Quality'],
    },
    specifications: [
      { label: 'Sugar Content', value: '12-15%' },
      { label: 'Moisture Content', value: 'Max 75%' },
      { label: 'Kernel Size', value: 'Uniform' },
      { label: 'Color', value: 'Golden Yellow' },
    ],
  },

  // COFFEE
  {
    id: 20,
    name: 'Arabica Coffee Powder',
    category: 'Coffee',
    description: 'Premium Arabica coffee powder with smooth, aromatic flavor profile. Sourced from high-altitude plantations for superior quality.',
    image: 'https://readdy.ai/api/search-image?query=Close%20up%20macro%20shot%20of%20arabica%20coffee%20powder%20showing%20fine%20ground%20coffee%20with%20rich%20dark%20brown%20color%20and%20smooth%20powdery%20texture%20arranged%20in%20a%20neat%20pile%20on%20white%20background%20professional%20coffee%20product%20photography%20high%20resolution%20sharp%20focus%20for%20export%20catalog&width=400&height=400&seq=arabica-coffee-v2&orientation=squarish',
    details: {
      origin: 'Karnataka (Coorg), India',
      packaging: '250g, 500g, 1kg',
      shelfLife: '12 months',
      certifications: ['FSSAI', 'ISO 22000', 'Coffee Board Certified'],
    },
    specifications: [
      { label: 'Moisture Content', value: 'Max 5%' },
      { label: 'Caffeine Content', value: '1.2-1.5%' },
      { label: 'Acidity Level', value: 'Medium-High' },
      { label: 'Roast Level', value: 'Medium Roast' },
    ],
  },
  {
    id: 21,
    name: 'Robusta Coffee Powder',
    category: 'Coffee',
    description: 'Strong and bold Robusta coffee powder with rich crema. Perfect for espresso blends and strong coffee preferences.',
    image: 'https://readdy.ai/api/search-image?query=Detailed%20macro%20photography%20of%20robusta%20coffee%20powder%20showing%20fine%20ground%20coffee%20with%20deep%20dark%20brown%20almost%20black%20color%20and%20smooth%20texture%20arranged%20in%20a%20pile%20on%20pure%20white%20background%20professional%20product%20photography%20sharp%20focus%20for%20agricultural%20export%20catalog&width=400&height=400&seq=robusta-coffee-v2&orientation=squarish',
    details: {
      origin: 'Kerala, India',
      packaging: '250g, 500g, 1kg',
      shelfLife: '12 months',
      certifications: ['FSSAI', 'ISO 22000', 'Coffee Board Certified'],
    },
    specifications: [
      { label: 'Moisture Content', value: 'Max 5%' },
      { label: 'Caffeine Content', value: '2.2-2.7%' },
      { label: 'Acidity Level', value: 'Low' },
      { label: 'Roast Level', value: 'Dark Roast' },
    ],
  },
  {
    id: 22,
    name: 'Coffee Blend (80-20)',
    category: 'Coffee',
    description: 'Expertly crafted blend of 80% Arabica and 20% Robusta. Balanced flavor profile combining smoothness with strength.',
    image: 'https://readdy.ai/api/search-image?query=High%20resolution%20macro%20shot%20of%20coffee%20blend%20powder%20showing%20medium%20dark%20brown%20finely%20ground%20coffee%20with%20smooth%20uniform%20texture%20arranged%20in%20a%20neat%20pile%20on%20white%20background%20professional%20coffee%20photography%20sharp%20detail%20for%20export%20quality%20catalog&width=400&height=400&seq=coffee-blend-v2&orientation=squarish',
    details: {
      origin: 'Karnataka, India',
      packaging: '250g, 500g, 1kg',
      shelfLife: '12 months',
      certifications: ['FSSAI', 'ISO 22000', 'Coffee Board Certified'],
    },
    specifications: [
      { label: 'Arabica Content', value: '80%' },
      { label: 'Robusta Content', value: '20%' },
      { label: 'Moisture Content', value: 'Max 5%' },
      { label: 'Roast Level', value: 'Medium-Dark' },
    ],
  },

  // TEA
  {
    id: 23,
    name: 'Assam Black Tea',
    category: 'Tea Powder',
    description: 'Premium Assam black tea with malty flavor and bright liquor. Sourced from renowned Assam tea gardens for authentic taste.',
    image: 'https://readdy.ai/api/search-image?query=Detailed%20close%20up%20macro%20photography%20of%20assam%20black%20tea%20powder%20showing%20fine%20ground%20tea%20leaves%20with%20dark%20brown%20black%20color%20and%20characteristic%20tea%20texture%20arranged%20on%20pure%20white%20background%20professional%20tea%20product%20photography%20high%20detail%20sharp%20focus%20for%20export%20catalog&width=400&height=400&seq=assam-tea-v2&orientation=squarish',
    details: {
      origin: 'Assam, India',
      packaging: '100g, 250g, 500g, 1kg',
      shelfLife: '18 months',
      certifications: ['FSSAI', 'ISO 22000', 'Tea Board Certified'],
    },
    specifications: [
      { label: 'Moisture Content', value: 'Max 7%' },
      { label: 'Total Ash', value: 'Max 6.5%' },
      { label: 'Grade', value: 'CTC/Orthodox' },
      { label: 'Liquor Color', value: 'Bright Coppery' },
    ],
  },
  {
    id: 24,
    name: 'Darjeeling Tea',
    category: 'Tea Powder',
    description: 'Exquisite Darjeeling tea known as the champagne of teas. Light, floral, and aromatic with distinctive muscatel flavor.',
    image: 'https://readdy.ai/api/search-image?query=High%20resolution%20macro%20shot%20of%20darjeeling%20tea%20powder%20showing%20fine%20ground%20tea%20leaves%20with%20medium%20brown%20color%20and%20delicate%20texture%20arranged%20in%20a%20neat%20pile%20on%20white%20background%20professional%20tea%20photography%20sharp%20focus%20high%20detail%20for%20agricultural%20export%20quality%20catalog&width=400&height=400&seq=darjeeling-tea-v2&orientation=squarish',
    details: {
      origin: 'Darjeeling, West Bengal',
      packaging: '100g, 250g, 500g',
      shelfLife: '18 months',
      certifications: ['FSSAI', 'ISO 22000', 'Tea Board Certified', 'GI Tag'],
    },
    specifications: [
      { label: 'Moisture Content', value: 'Max 7%' },
      { label: 'Total Ash', value: 'Max 6%' },
      { label: 'Grade', value: 'Orthodox' },
      { label: 'Flush', value: 'First/Second' },
    ],
  },
];
